import { createReducer, on } from '@ngrx/store';
import { 
  userLogin,
  userLoginSuccess,
  userLoginFailure,
  userSendVerification,
  userSendVerificationSuccess,
  userSendVerificationFailure,
  userResetPassword,
  userResetPasswordSuccess,
  userResetPasswordFailure,
  userchangePassword,
  userchangePasswordSuccess,
  userchangePasswordFailure,
  userSignup,
  userSignupSuccess,
  userSignupFailure,
  userLogout,
  updateUserProfile,
  updateUserProfileSuccess,
  updateUserProfileFailure,
  updateUserToken,
  getUser,
  getUserSuccess,
  getUserFailure,
  addFilter,
  addFilterFailure,
  addFilterSuccess,
  getFilters,
  getFiltersSuccess,
  getFiltersFailure,
  getFilter,
  getFilterSuccess,
  getFilterFailure,
  deleteFilter,
  deleteFilterSuccess,
  deleteFilterFailure,
  UpdateUser,
  UpdateUserSuccess,
  UpdateUserFailure,
  getUserLoginHistories,
  getUserLoginHistoriesSuccess,
  getUserLoginHistoriesFailure,
  userSendActivation,
  userSendActivationSuccess,
  userSendActivationFailure,
  resendVerification,
 } from './user.actions';
import { UserState } from '@models/index';

const initialState: UserState = {
  authToken: '',
  isLoaded: false,
  isPasswordUpdated: false,
  error: null,
  user: {},
  isRegistrated: false,
  loginHistories: {
    isLoaded: false,
    error: null,
    data: [],
    selectedItem: {},
    total: 0,
    maxPages: 0,
    perPage: 0,
    currentPage: 0
  },
  filters: {
    isLoaded: false,
    error: null,
    data: [],
    selectedItem: {},
    total: 0,
    maxPages: 0,
    perPage: 0,
    currentPage: 0
  }
};

const _userReducer = createReducer(
  initialState,
  on(userLogin, (state, { email, password }) => {
    return state;
  }),
  on(userLoginSuccess, (state, { user }) => {
    const payload = {
      isLoaded: true,
      authToken: user.access_token,
      user: user.user
    };

    return { ...state, ...payload };
  }),
  on(userLoginFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(userSendVerification, (state, { email }) => {
    return state;
  }),
  on(userSendVerificationSuccess, (state, { user }) => {
    const payload = {
      isLoaded: true,
      error: null
      // user
    };
    return { ...state, ...payload };
  }),
  on(userSendVerificationFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(userResetPassword, (state, { password, hash }) => {
    return state;
  }),
  on(userResetPasswordSuccess, (state, { user }) => {
    const payload = {
      isLoaded: true,
      error: null
    };
    return { ...state, ...payload };
  }),
  on(userResetPasswordFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(userchangePassword, (state, {  options }) => {
    const payload = {
      error: null,
      isPasswordUpdated: false
    };
    return { ...state, ...payload };
  }),
  on(userchangePasswordSuccess, (state,  passByUser ) => {
    const payload = {
      error: null,
      isPasswordUpdated: true
    };
    return { ...state, ...payload };
  }),
  on(userchangePasswordFailure, (state, { error }) => {
    const payload = {
      error
    };
    return { ...state, ...payload };
  }),
  on(resendVerification,(state,{email})=>{
    console.log(state);
    console.log(email);
    return state;
  }),
  on(userSignup, (state, { user }) => {
    const payload = {
      isRegistrated: false,
    };
    return { ...state, ...payload };
  }),
  on(userSignupSuccess, (state, { user }) => {
    const payload = {
      isRegistrated: true,
      user
    };

    return { ...state, ...payload };
  }),
  on(userSignupFailure, (state, { error }) => {
    const payload = {
      isRegistrated: false,
      error
    };
    return { ...state, ...payload };
  }),
  
  on(updateUserToken , (state , { authToken }) => { 
    return { ...state, authToken: authToken } 
  }),
  on(updateUserProfile, (state) => {
    
    return state;
  }),
  on(updateUserProfileSuccess, (state, { user }) => {
    const payload = {
      isLoaded: true,
      user: user
    };

    return { ...state, ...payload };
  }),
  on(updateUserProfileFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(userLogout, (state) => {
    const payload = {
      authToken: '',
      isLoaded: false,
      error: null,
      user: {},
      isRegistrated: false,
      filters: {
        isLoaded: false,
        error: null,
        data: [],
        selectedItem: {},
        total: 0,
        maxPages: 0,
        perPage: 0,
        currentPage: 0
      }
    };
    return { ...state, ...payload };
  }),
  on(getUser, (state, { id }) => {
    const payload = {
      isLoaded: false
    };
    return { ...state, ...payload };
  }),
  on(getUserSuccess, (state, { user }) => {
    const payload = {
      isLoaded: true,
      user
    };
    return { ...state, ...payload };
  }),
  on(getUserFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(addFilter, (state, { filter }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: false }
    };
    return { ...state, ...payload };
  }),
  on(addFilterSuccess, (state, { filter }) => {
    const total = state.filters.total < 30 ? state.filters.total + 1 : state.filters.total;
    const payload = {
      filters: { ...state.filters, isLoaded: true, total, data: [ {...filter} , ...state.filters['data']] }
    };
    return { ...state, ...payload };
  }),
  on(addFilterFailure, (state, { error }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: true, error }
    };
    return { ...state, ...payload };
  }),
  on(getFilters, (state) => {
    const payload = {
      filters: { ...state.filters, isLoaded: false }
    };
    return { ...state, ...payload };
  }),
  on(getFiltersSuccess, (state, { filters }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: true, ...filters }
    };
    return { ...state, ...payload };
  }),
  on(getFiltersFailure, (state, { error }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: true, error }
    };
    return { ...state, ...payload };
  }),
  on(getFilter, (state, { id }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: false }
    };
    return { ...state, ...payload };
  }),
  on(getFilterSuccess, (state, { filter }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: true, selectedItem: filter }
    };
    return { ...state, ...payload };
  }),
  on(getFilterFailure, (state, { error }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: true, error }
    };
    return { ...state, ...payload };
  }),
  on(deleteFilter, (state, { id }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: false }
    };
    return { ...state, ...payload };
  }),
  on(deleteFilterSuccess, (state, { id }) => {
    const payload = {
      filters: { 
        ...state.filters, 
        isLoaded: true, 
        data: [...state.filters.data.filter(item => item.id != id)]
      }
    };
    return { ...state, ...payload };
  }),
  on(deleteFilterFailure, (state, { error }) => {
    const payload = {
      filters: { ...state.filters, isLoaded: true, error }
    };
    return { ...state, ...payload };
  }),
  on(UpdateUser, (state, { user }) => {
    return state;
  }),
  on(UpdateUserSuccess, (state, { user }) => {
    return {
      ...state,
      error: null,
      user: { ...state.user, ...user }
    };
  }),
  on(UpdateUserFailure, (state, { error }) => {
    const payload = {
      error
    };
    return { ...state, ...payload };
  }),
  on(getUserLoginHistories, (state, { userID, page, filterOptions }) => {
    const payload = {
      loginHistories: {
        isLoaded: false
      }
    };

    return { ...state, ...payload };
  }),
  on(getUserLoginHistoriesSuccess, (state, { loginHistories }) => {
    const payload = {
      loginHistories: {
        isLoaded: true,
        data: loginHistories.data,
        total: loginHistories.total,
        maxPages: loginHistories.maxPages,
        perPage: loginHistories.perPage,
        currentPage: loginHistories.currentPage,
        selectedItem: {}
      }
    };
    return { ...state, ...payload };
  }),
  on(getUserLoginHistoriesFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(userSendActivation, (state, { code, email }) => {
    return state;
  }),
  on(userSendActivationSuccess, (state, { user }) => {
    const payload = {
      isLoaded: true,
      error: null,
      authToken: user['authToken']
    };
    return { ...state, ...payload };
  }),
  on(userSendActivationFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  })

);

export function userReducer(state, action) {
  return _userReducer(state, action);
}
